
// for online containers the backend api env variable is given. 
// fallback to localhost for development
const API_BASE_URL = window.env?.BACKEND_API || 'http://localhost:8080';

export const AUTH_ENDPOINTS = {
    GET_REFRESH_TOKEN: `${API_BASE_URL}/auth/refresh-auth-token`,
    POST_VERIFY_EMAIL: `${API_BASE_URL}/auth/verify-email`,
    POST_SEND_FORGOT_PASSWORD_EMAIL: `${API_BASE_URL}/auth/send-forgot-password-email`,
    POST_CHANGE_PASSWORD: `${API_BASE_URL}/auth/change-password`,
    POST_SEND_VERIFICATION_EMAIL: `${API_BASE_URL}/auth/send-verification-email`,
    POST_EMPLOYER_SIGNUP: `${API_BASE_URL}/auth/employers/signup`,
    POST_EMPLOYER_LOGIN: `${API_BASE_URL}/auth/employers/login`,
    POST_FREELANCER_SIGNUP: `${API_BASE_URL}/auth/freelancers/signup`,
    POST_FREELANCER_LOGIN: `${API_BASE_URL}/auth/freelancers/login`,
}

export const EMPLOYER_ENDPOINTS = {
    GET_EMPLOYER_BY_ID: `${API_BASE_URL}/employers`,
}

export const FREELANCER_ENDPOINTS = {
    GET_FREELANCER_BY_ID: `${API_BASE_URL}/freelancers`,
}

export const WALLET_ENDPOINTS = {
    GET_WALLET: `${API_BASE_URL}/wallets/`,
}

export const PARTNERS_AND_AFFILIATES_ENDPOINTS = {
    GET_PARTNERS_AND_AFFILIATES: `${API_BASE_URL}/partners-and-affiliates/`,
}

export const USER_ENDPOINTS = {
    GET_ME_FULL: `${API_BASE_URL}/users/me-full`,
    GET_ME_BRIEF: `${API_BASE_URL}/users/me-brief`,
    PUT_ME: `${API_BASE_URL}/users/me`,

    GET_SIGNED_URL_PROFILE_PICTURE: `${API_BASE_URL}/users/me/profile-picture/upload-url`,
    POST_CONFIRM_PROFILE_PICTURE_UPLOAD: `${API_BASE_URL}/users/me/profile-picture/confirm-upload`,
    GET_SIGNED_URL_TITLE_PICTURE: `${API_BASE_URL}/users/me/title-picture/upload-url`,
    POST_CONFIRM_PROFILE_TITLE_PICTURE_UPLOAD: `${API_BASE_URL}/users/me/title-picture/confirm-upload`,

    GET_FREELANCER_BY_ID: `${API_BASE_URL}/freelancers`,
    POST_FREELANCERS_MULTIPLE_BRIEF: `${API_BASE_URL}/freelancers/multiple-brief`,
    POST_FREELANCERS_MULTIPLE_FULL: `${API_BASE_URL}/freelancers/multiple-full`,
    POST_FREELANCER_BY_FILTER: `${API_BASE_URL}/freelancers`, // this one is POST because post can serialize filters better in the body but actually its a GET
    GET_EMPLOYER_BY_ID: `${API_BASE_URL}/employers`,
    POST_EMPLOYERS_MULTIPLE_BRIEF: `${API_BASE_URL}/employers/multiple-brief`,
    POST_SEARCH_FREELANCERS: `${API_BASE_URL}/freelancers/search`, // this one is POST because post can serialize filters better in the body but actually its a GET
}

export const PROJECT_ENDPOINTS = {
    GET_PROJECT_BY_ID: `${API_BASE_URL}/projects/single`, // /projects/single/:id
    POST_GET_PROJECTS_BY_FILTER: `${API_BASE_URL}/projects/multiple`,
    GET_MY_PROJECTS: `${API_BASE_URL}/projects/my-projects`,
    GET_MY_PROJECTS_AS_PM: `${API_BASE_URL}/projects/my-projects-as-pm`,
    GET_MY_UNASSIGNED_PROJECTS: `${API_BASE_URL}/projects/my-unassigned-projects`,
    GET_PROJECT_AI_SUGGEST_REFINED_DETAILS: `${API_BASE_URL}/projects/ai/suggest-refined-details`,
    GET_PROJECT_AI_POTENTIAL_WEAKNESSES: `${API_BASE_URL}/projects/ai/potential-weaknesses`,
    POST_PROJECT: `${API_BASE_URL}/projects`,
    POST_PROJECT_ROADMAP_PDF: `${API_BASE_URL}/projects/roadmap-pdf`, // /projects/roadmap-pdf/:projectid
    POST_PROJECT_ROADMAP_VERIFICATION_TRIGGER: `${API_BASE_URL}/projects/roadmap-verification/trigger`, // /projects/roadmap-verification/trigger/:projectid
    POST_PROJECT_ROADMAP_VERIFICATION_VERIFY: `${API_BASE_URL}/projects/roadmap-verification/complete`, // /projects/roadmap-verification/complete/:projectid
    POST_PROJECT_ROADMAP_VERIFICATION_PM_AGREE_TO_CONTINUE: `${API_BASE_URL}/projects/roadmap-verification/pm-agree-to-continue`, // /projects/roadmap-verification/pm-agree-to-continue/:projectid
    PUT_PROJECT_START_SELF_MANAGED: `${API_BASE_URL}/projects/start/self-managed`, // /projects/start/self-managed/:projectid
    PUT_PROJECT_START_WITH_PM: `${API_BASE_URL}/projects/start/with-pm`, // /projects/start/with-pm/:projectid
    PUT_PROJECT_UPDATE_DETAILS: `${API_BASE_URL}/projects/details`, // /projects/details
    PUT_PROJECT_PUBLISH: `${API_BASE_URL}/projects/publish`, // /projects/publish/:id
    PUT_REQUEST_APPROVAL: `${API_BASE_URL}/projects/approval/request`, // /projects/approval/request/:id
    PUT_REJECT_APPROVAL_REQUEST: `${API_BASE_URL}/projects/approval/reject`, // /projects/approval/reject/:id
    PUT_PROJECT_APPROVE_DETAILS: `${API_BASE_URL}/projects/approve-details`, // /projects/approve-details/:id
    PUT_REQUEST_COMPLETION: `${API_BASE_URL}/projects/request-completion`, // /projects/request-completion/:id
    PUT_REJECT_COMPLETION_REQUEST: `${API_BASE_URL}/projects/reject-completion-request`, // /projects/reject-completion-request/:id
    PUT_PROJECT_COMPLETE: `${API_BASE_URL}/projects/complete`, // /projects/complete/:id

    DELETE_PROJECT_DRAFT: `${API_BASE_URL}/projects/draft`, // /projects/draft/:id
}

export const TASK_ENDPOINTS = {
    GET_TASK_BY_ID: `${API_BASE_URL}/tasks`, // /tasks/:id
    GET_TASKS_BY_PROJECT_ID: `${API_BASE_URL}/tasks/project`, // /tasks/project/:projectId
    GET_AVAILABLE_TASKS_ALL: `${API_BASE_URL}/tasks/available/all`,
    GET_AVAILABLE_TASKS_BY_FILTER: `${API_BASE_URL}/tasks/available`,
    GET_UNASSIGNED_TASKS: `${API_BASE_URL}/tasks/unassigned/all`,
    GET_UNASSIGNED_TASKS_AS_PM: `${API_BASE_URL}/tasks/unassigned/as-pm`,

    POST_TASK: `${API_BASE_URL}/tasks`,
    POST_TASKS_AI_GENERATE_MULTIPLE: `${API_BASE_URL}/tasks/ai/generate/multiple`,
    POST_MULTIPLE_TASKS_BY_IDS: `${API_BASE_URL}/tasks/multiple-by-ids`, // this should actually be a get - change later 
    POST_TASKS_BY_FILTER: `${API_BASE_URL}/tasks/multiple-by-filter`, // this should actually be a get - change later 
    POST_TASKS_FOR_PM_BY_FILTER: `${API_BASE_URL}/tasks/multiple-for-pm-by-filter`, // this should actually be a get - change later 
    POST_SHORTLIST_FREELANCER_TOGGLE: `${API_BASE_URL}/tasks/shortlist`, // /tasks/shortlist/:taskid/:freelancerid

    PUT_TASK: `${API_BASE_URL}/tasks`, // /tasks/:taskid
    PUT_TASK_ACTUAL_EFFORT: `${API_BASE_URL}/tasks/actual-effort/hours`, // /tasks/actual-effort/:taskid/:hours
    PUT_TASK_APPROVE: `${API_BASE_URL}/tasks/approve`, // /tasks/approve/:taskid
    PUT_TASK_COMPLETE: `${API_BASE_URL}/tasks/complete`, // /tasks/complete/:taskid
    PUT_TASK_CANCEL: `${API_BASE_URL}/tasks/cancel`, // /tasks/cancel/:taskid
    PUT_PUSH_TASK_RANK: `${API_BASE_URL}/tasks/rank`, // /tasks/rank/:taskid/:rank
    PUT_TASK_STATUS: `${API_BASE_URL}/tasks/status`, // /tasks/status/:taskid
    PUT_TASK_START_AND_PAY: `${API_BASE_URL}/tasks/start-and-pay`, // /tasks/start-and-pay/:taskid

    DELETE_TASK: `${API_BASE_URL}/tasks`, // /tasks/:taskid
    DELETE_UNASSIGN_FREELANCER: `${API_BASE_URL}/tasks/unassign`, // /tasks/unassign/:taskid

    POST_COMMENT_TO_TASK: `${API_BASE_URL}/tasks/comments`, // /tasks/comments/:taskid
    POST_REVISION_TO_TASK: `${API_BASE_URL}/tasks/revisions`, // /tasks/revisions/:taskid
    PUT_TOGGLE_LIKE_COMMENT: `${API_BASE_URL}/tasks/comments/toggle-like`, // /tasks/comments/toggle-like/:taskid/:commentid
    DELETE_COMMENT: `${API_BASE_URL}/tasks/comments`, // /tasks/comments/:taskid/:commentid
}

export const TASK_APPLICATION_ENDPOINTS = {
    GET_APPLICATIONS_FOR_PROJECT: `${API_BASE_URL}/applications/projects`, // /applications/:projectid
    GET_APPLICATIONS_FOR_USER: `${API_BASE_URL}/applications`, // /applications
    GET_ALIVE_APPLICATIONS_AS_PM: `${API_BASE_URL}/applications/alive-as-pm`,
    GET_NUMBER_OF_APPLICATIONS_FOR_PROJECT: `${API_BASE_URL}/applications/amount/project`, // /applications/amount/project/:projectid
    POST_APPLICATION: `${API_BASE_URL}/applications`,
    POST_APPLICATION_BULK: `${API_BASE_URL}/applications/bulk`,
    POST_PM_APPLICATION: `${API_BASE_URL}/applications/pm`,
    PUT_APPLICATION_ACCEPT: `${API_BASE_URL}/applications/accept`, // /applications/accept/:applicationid
    PUT_APPLICATION_REJECT: `${API_BASE_URL}/applications/reject`, // /applications/reject/:applicationid
    PUT_APPLICATION_CONFIRM: `${API_BASE_URL}/applications/confirm`, // /applications/confirm/:applicationid
    PUT_APPLICATION_REFUSE: `${API_BASE_URL}/applications/refuse`, // /applications/refuse/:applicationid
}

export const TASK_INVITATION_ENDPOINTS = {
    GET_INVITATION_BY_ID: `${API_BASE_URL}/invitations`, // /invitations/:id
    GET_INVITATIONS_FOR_USER: `${API_BASE_URL}/invitations/filter/for`,
    GET_INVITATIONS_FROM_USER: `${API_BASE_URL}/invitations/filter/from`,
    GET_ALIVE_INVITATIONS_FROM_PM: `${API_BASE_URL}/invitations/filter/alive-from-pm`,
    GET_INVITATIONS_FOR_PROJECT: `${API_BASE_URL}/invitations/filter/project`,
    GET_INVITATIONS_FOR_TASK: `${API_BASE_URL}/invitations/filter/task`, // /invitations/filter/task/:taskid
    GET_NUMBER_OF_INVITATIONS_FOR_PROJECT: `${API_BASE_URL}/invitations/amount/project`, // /invitations/amount/project/:projectid
    POST_INVITATION: `${API_BASE_URL}/invitations`,
    POST_INVITATION_BULK: `${API_BASE_URL}/invitations/bulk`,
    PUT_INVITATION_ACCEPT: `${API_BASE_URL}/invitations/accept`, // /invitations/accept/:invitationid
    PUT_INVITATION_DECLINE: `${API_BASE_URL}/invitations/decline`, // /invitations/decline/:invitationid
    PUT_INVITATION_WITHDRAW: `${API_BASE_URL}/invitations/withdraw`, // /invitations/withdraw/:invitationid
    PUT_MARK_AS_SEEN_BY_FREELANCER: `${API_BASE_URL}/invitations/mark-as-seen`, // /invitations/mark-as-seen/:invitationid
}

export const CHAT_ENDPOINTS = {
    POST_SEND_PRIVATE_MESSAGE: `${API_BASE_URL}/messaging/private`,
    GET_SIGNED_URL_UPLOAD_PRIVATE: `${API_BASE_URL}/messaging/private/signed-url/upload`,
    GET_SIGNET_URL_DOWNLOAD_PRIVATE: `${API_BASE_URL}/messaging/private/signed-url/download`,
    POST_CONFIRM_UPLOAD_PRIVATE: `${API_BASE_URL}/messaging/private/confirm-upload`,
    POST_MARK_AS_READ: `${API_BASE_URL}/messaging/private/mark-as-read`,

    POST_NOTIFY_TYPING: `${API_BASE_URL}/conversations/notify-typing`, // /conversations/notify-typing/:conversationId
    GET_ALL_ONE_TO_ONE_CONVERSATIONS: `${API_BASE_URL}/conversations/private`,
    GET_ONE_TO_ONE_CONVERSATION_BY_ID: `${API_BASE_URL}/conversations/private`, // /conversations/private/:id
    GET_ONE_TO_ONE_CONVERSATION_BY_PARTNER_ID: `${API_BASE_URL}/conversations/private/partner`, // /conversations/private/partner/:partnerId/:partnerUserType
    GET_PARTNERS_BY_CONVERSATION_ID: `${API_BASE_URL}/conversations/partners`, // /conversations/partners/:conversationId
    GET_MESSAGES_BY_CONVERSATION_ID: `${API_BASE_URL}/conversations/messages`, // /conversations/messages/:conversationId
}

export const CREDITS_ENDPOINTS = {
    GET_RATE_CREDITS_TO_USD_FREELANCER: `${API_BASE_URL}/credits/rate-usd/freelancer`,
    GET_RATE_CREDITS_TO_USD_EMPLOYER: `${API_BASE_URL}/credits/rate-usd/employer`,
    GET_COSTS_NDA: `${API_BASE_URL}/credits/costs/nda`,
    GET_PM_PAYOUT_AFTER_TASK_COMPLETED: `${API_BASE_URL}/credits/payout/pm/task-completed`,
    GET_PM_PAYOUT_AFTER_PROJECT_COMPLETED: `${API_BASE_URL}/credits/payout/pm/project-completed`,
}

export const CONFIG_ENDPOINTS = {
    GET_CONFIG: `${API_BASE_URL}/config/full`,
}

export const ARIELLE_ENDPOINTS = {
    GET_IS_PROCESSING: `${API_BASE_URL}/arielle/is-processing`,
    GET_ARIELLE_PROCESSING: `${API_BASE_URL}/arielle/arielle-processing`,
    POST_PROJECT_DETAILS: `${API_BASE_URL}/arielle/project-details`,
    POST_PROJECT_ROADMAP: `${API_BASE_URL}/arielle/project-roadmap`,
    POST_BRIEF_TASK_DESCRIPTION: `${API_BASE_URL}/arielle/brief-task-description`,
    POST_TASK_TITLE: `${API_BASE_URL}/arielle/task-title`,
    POST_TASK_DESCRIPTION: `${API_BASE_URL}/arielle/task-description`,
    POST_TASK_DEFINITION_OF_DONE: `${API_BASE_URL}/arielle/task-definition-of-done`,
    DELETE_ARIELLE_PROCESSING: `${API_BASE_URL}/arielle/remove-arielle-processing`,
}